module.exports = __webpack_public_path__ + "img/treeSettings.7734e52d.png";